import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';
import DateRange from 'components/common/general/DateRange';
import DownloadFilesTable from 'components/common/download-files/DownloadFilesTable';
import { createStyles } from './styles';

const BookOfBusinessTable = observer((): JSX.Element => {
  const classes = createStyles();

  const {
    bookOfBusinessStore: { loading, getMaintenanceFileIdsByDate, downloadFile, maintenanceFiles },
  } = useRootStore();

  const convertedMaintenanceFiles = maintenanceFiles.map((info) => toJS(info)).slice();
  const sortedFiles = convertedMaintenanceFiles.sort((a, b) => (a.name > b.name ? 1 : -1));

  const updateTableByDateRange = (dateFrom: string, dateTo: string, fullAgencyView: boolean): void => {
    void getMaintenanceFileIdsByDate(dateFrom, dateTo, fullAgencyView);
  };

  return (
    <div>
      <div className={classes.infoWrapper}>
        <DateRange updateTableByDateRange={updateTableByDateRange} />
      </div>
      <DownloadFilesTable loading={loading} filesList={sortedFiles} onDownload={downloadFile} />
    </div>
  );
});

export default BookOfBusinessTable;
